import laVilaCover from '../../../assets/images/la-villa-restaurant.jpg';
import shanghaiCover from '../../../assets/images/shanghai-restaurant.jpg';
import shanghaiCover1 from '../../../assets/images/food/shanghai/shanghai4.jpeg';
import { abstract, lavillaAbout, shanghaiAbout } from './restaurants';

const frontpage= {
  subtitle: 'Mediteranska, Kineska i Suši Kuhinja ',
  welcome: {
    title: 'O Hotelu',
    subtitle: 'La Villa Boutique Hotel vam želi toplu dobrodošlicu i prijatan boravak u hotelu',
    body:
      'Osjetite šarm Starog grada, uživajuci u  komfornom i modernom mediteranskom ambijentu sa pogledom na marinu i  Stari grad Budvu.Sofisticirani  butik hotel  koji nudi privatnost u samo pet potpuno opremljenih i klimatizovanih apartmana. Svi apartmani nude potpuni komfor, veliki bračni krevet, sofu na razvlačenje, TV sa mnoštvom kanala, besplatan Wi-Fi u svim prostorima hotela, moderno kupatilo sa luksuznim bade mantilima i hotelskom kozmetikom, veliki sef za lap top i vrijedne lične stvari, parking i jos dosta toga  za kompletno uživanje. Hotel se nalazi u istorijskoj zgradi iz 17. vijeka, lociran u mirnom dijelu Starog grada koji je pod zaštitom UNESCO-a.\n\n' +
      'Pored idilicne pozicije La Ville, kratkom šetnjom budvanskom marinom i  udaljenošću od 20 km od najbližeg aerodroma, gosti imaju mogućnost da uživaju i u gastronomskim avanturama. Predstavljamo vam naš Shanghai restoran  inspirisan azijskom kuhinjom.\n\n' +
      'Dok sjedite u natkrivenoj terasi restorana  osunčanoj  divnim zracima sunca, uživajte u ukusnom azijskom meniju prema vašem izboru: kineskoj kuhinji ili japanskim sushi delikatesima.\n' +
      'Svim gostima koji borave u La Villa Boutique Hotelu, priprema  se bogat  a la carte doručak koji je uključen u cijenu smještaja.\n\n' +
      'Doručak se servira u elegantnom La Villa restoranu  ili na njegovoj terasi zaklonjenoj od pogleda prolaznika.\n\n' +
      'La Villa Boutique Hotel vam nudi širok  izbor izleta i aktivnosti van hotela, skrojenih po vašoj želji a koji će vam omogućiti da se upoznate sa ljepotama Crne Gore.\n\n' +
      'Bez obzira da li želite da iznajmite jahtu za cjelodnevni izlet, panoramsku vožnju budvanskim zalivom  ili vožnju podmornicom, ili pak  želite transfer sa aerodroma Tivat, Podgorica ili Dubrovnik, naš posvećeni tim će biti srećan da organizuje najbolje za vaš komfor i uživanje.\n\n' +
      'Krstarenje budvanskim  ili  bokokotorskim zalivom,  vožnja kajakom ili padobranom, degustacija crnogorskog vina i nacionalnih jela, izlet na Skadarsko jezero i jos mnogo toga, su najpopularnije akrivnosti medju našim gostima.\n',
  },
  restaurants: {
    common: { body: abstract },
    left: {
      title: 'Shanghai',
      linkTo: '/restaurant/shanghai',
      logo: require('../../../assets/images/shanghaiLogo.png'),
      cover: shanghaiCover,
      cover1: shanghaiCover1,
      body: shanghaiAbout,
    },
    right: {
      title: 'LaVilla',
      linkTo: '/restaurant/lavilla',
      logo: require('../../../assets/images/laVillaLogo.png'),
      cover: laVilaCover,
      body: lavillaAbout,
    },
  },
  team: {
    title: 'Zašto La Villa?',
    about:
      'Zato što ćemo organizovati ljetovanje baš po Vašoj mjeri, do najsitnijeg detalja.\n Zato što će odmor koji čekate čitave godine biti baš ono o čemu ste maštali.\n Zato što ljubaznost, toplinu i dobro raspoloženje ne naplaćujemo, nego delimo sa Vama.',
    members: [
      // require('../../../assets/images/team/team1.jpeg'),
      // require('../../../assets/images/team/team2.jpeg'),
      require('../../../assets/images/team/team3.jpeg'),
      require('../../../assets/images/team/team4.jpeg'),
      // require('../../../assets/images/team/team5.jpeg'),
    ],
  },
};

export default frontpage;